import { Box, Button, Divider, Modal, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import * as S from './styles'

interface ModalProps {
	isModalOpened: boolean
	numProducts: number
	onCancel: () => void
	onConfirm: () => Promise<void>
}

const DeleteProductsModal = (props: ModalProps) => {
	const { isModalOpened, numProducts, onCancel, onConfirm } = props
	const { t } = useTranslation()

	return (
		<Modal open={isModalOpened} onClose={onCancel}>
			<S.BackdropWithModalStyles>
				<Typography variant="h2">{t('modal.deleteProducts.title')}</Typography>
				<Box pb={4} pt={1}>
					<Divider />
				</Box>

				<Typography
					variant="subtitle2"
					component="h5"
					color="textSecondary"
					style={{ marginBottom: '20px' }}
				>
					{t('modal.deleteProducts.text', { count: numProducts })}
					<br />
					{t('modal.deleteProducts.textSecondLine')}
				</Typography>

				<Box
					mt={4}
					display="flex"
					justifyContent="space-around"
					className="delete-products-modal-action-part"
				>
					<Button
						className="delete-products-modal-cancel-button"
						variant="outlined"
						color="primary"
						onClick={onCancel}
					>
						{t('button.cancel')}
					</Button>
					<Button variant="contained" color="primary" onClick={onConfirm}>
						{t('button.delete')}
					</Button>
				</Box>
			</S.BackdropWithModalStyles>
		</Modal>
	)
}

export { DeleteProductsModal }
